import {List, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {DataInfo} from 'presentation/components';
import {formatText} from 'presentation/utils';
import {StyledCard} from './styles';
import {ContentProps, HeaderProps, RootProps} from './types';

function Root({customBorderColor, children, ...cardProps}: RootProps) {
	return (
		<StyledCard elevation={0} $customBorderColor={customBorderColor} {...cardProps}>
			<Stack gap={1}>{children}</Stack>
		</StyledCard>
	);
}

function Header({subheader, children}: HeaderProps) {
	return (
		<Fragment>
			<Typography variant="subheader">{subheader}</Typography>
			{children}
		</Fragment>
	);
}

function Content({
	iconName,
	primaryText,
	secondaryText,
	children,
	height,
	disableMargin,
	primaryTextColor,
	secondaryTextColor,
}: ContentProps) {
	return (
		<List disablePadding sx={{height: height ?? 'auto'}}>
			<DataInfo
				primaryText={formatText(primaryText)}
				primaryTextColor={primaryTextColor}
				iconName={iconName}
				secondaryText={secondaryText}
				secondaryTextColor={secondaryTextColor}
				listItemProps={{sx: {p: 0}}}
				removeItemTextMargin={disableMargin}
			/>
			{children}
		</List>
	);
}

export const ConfirmationCard = {
	Root,
	Header,
	Content,
};
